import { CONTACTO, IconWhatsApp } from "./Social";

export default function Hero() {
    return (
        <section className="hero">
            <div className="hero-inner">
                <span className="eyebrow">Fotografía deportiva — {CONTACTO.ciudad}</span>
                <h1 className="hero-title display">Captura<br />la <em>fuerza.</em></h1>
                <p className="hero-lead">
                    Fútbol, básquet, box y tocho bandera: desde la cancha, la duela y el ring.
                    Cobertura de partidos, torneos y funciones.
                </p>
                <div className="hero-actions">
                    <a href="#portafolio" className="btn btn-volt">Ver portafolio ↓</a>
                    <a href={CONTACTO.whatsapp} className="btn" target="_blank" rel="noreferrer">
                        <IconWhatsApp /> Cotizar por WhatsApp
                    </a>
                </div>
            </div>
        </section>
    );
}
